import styled from "styled-components";
import errorIcon from "@icons/ic-error.svg";
import { BaseButton } from "@shared/styles/common.styled";

export const labelStyles = { fontWeight: "bold" };
export const noLabelStyles = { display: "none" };

export const inputStyles = {
  padding: "7px 5px 7px 10px",
};

export const inputStylesGreenBorder = {
  padding: "7px 5px 7px 10px",
  border: "1px solid #32a728 !important",
};

export const inputStylesBlueBorder = {
  padding: "7px 5px 7px 10px",
  border: "1px solid #15aee5 !important",
};

export const inputStylesGreyBorder = {
  padding: "7px 5px 7px 10px",
  border: "1px solid #474747 !important",
};

export const searchInputStyles = {
  padding: "4px 30px 4px 8px",
};

export const dropdownStylesGreenBorder = {
  padding: "1px 5px 1px 10px",
  border: "1px solid #32a728 !important",
};
export const dropdownStylesBlueBorder = {
  padding: "1px 5px 1px 10px",
  border: "1px solid #15aee5 !important",
};
export const dropdownStylesGreyBorder = {
  padding: "1px 5px 1px 10px",
  border: "1px solid #474747 !important",
};
export const dropdownStyles = {
  padding: "1px 5px 1px 10px",
};
export const dropdownStylesError = {
  padding: "1px 5px 1px 10px",
  border: "1px solid red !important",
  background: `url(${errorIcon}) no-repeat right`,
  "background-size": "26px 16px",
};

export const labelStylesError = { fontWeight: "bold", color: "red" };

export const inputStylesError = {
  padding: "7px 5px 7px 10px",
  border: "1px solid red !important",
  background: `url(${errorIcon}) no-repeat right`,
  "background-size": "26px 16px",
};

export const autoSearchInputStylesError = {
  border: "solid 1px red",
  borderRadius: "6px",
  background: `url(${errorIcon}) no-repeat right`,
  backgroundSize: "30px 20px",
};

export const autoSearchInputStyles = {
  border: "solid 0px #474747",
  borderRadius: "6px",
};

export const errorStyles = {
  fontStyle: "italic",
};

export const DivBackgroundLowOpacity = styled.div`
  opacity: 0.2;
`;

export const DivBackgroundFullOpacity = styled.div`
  opacity: 1;
`;

export const DivBackgroundOpacity = styled.div`
  opacity: ${(props) => props.opacity ?? "1"};
  display: ${(props) => props.display ?? "inline-block"};
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const DivOrangeBackground = styled.div`
  background: #ffecd6;
`;

export const DivToolTip = {
  maxWidth: "300px",
  wordBreak: "break-all",
  overflowWrap: "break-word",
  display: "block",
  zIndex: 99999,
};

export const DivToolTipCustom = {
  maxWidth: "500px",
  wordBreak: "break-all",
  overflowWrap: "break-word",
  display: "block",
  zIndex: 99999,
  padding: "2px",
  borderRadius: "3px",
  minWidth: "400px",
  background: "#004C7F",
  backgroundColor: "#004C7F",
};

export const RequiredMessage = styled.span`
  width: 100%;
  color: red;
  font-size: 0.875rem;
  font-family: "Lato";
  line-height: 1;
  margin: ${(props) => props.margin ?? "0"};
  padding: 0;
  max-width: ${(props) => props.maxWidth ?? "200px"};
`;

export const SuccessMessage = styled.span`
  width: 100%;
  color: green;
  font-size: 0.875rem;
  font-family: "Lato";
  line-height: 1;
  margin: ${(props) => props.margin ?? "0"};
  padding: 0;
  max-width: ${(props) => props.maxWidth ?? "200px"};
`;

export const ColumnButton = styled(BaseButton)`
  border: 1px solid ${(props) => props.border};
  background: ${(props) => props.background};
  font-weight: normal;
  width: ${(props) => props.width ?? "auto"};
  margin-right: ${(props) => props.marginRight ?? "0px"};
  margin-left: ${(props) => props.marginLeft ?? "0px"};
  margin-top: ${(props) => props.marginTop ?? "0px"};
  margin-bottom: ${(props) => props.marginBottom ?? "0px"};
  float: ${(props) => props.float ?? "none"};
  height: ${(props) => props.height ?? "auto"};
  border-radius: ${(props) => props.borderRadius ?? "4px"};
  padding: ${(props) => props.padding ?? "auto"};
  color: ${(props) => props.color ?? "white"};
`;

export const ListLinkContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const RequiredMessagePara = styled.p`
  width: 100%;
  color: red;
  font-size: 0.875rem;
  font-family: "Lato";
  line-height: 1;
  margin: ${(props) => props.margin ?? "0"};
  padding: 0;
  max-width: ${(props) => props.maxWidth ?? "200px"};
  font-style: ${(props) => props.fontStyle ?? "normal"};
`;

export const UndefinedMessageError = styled.p`
  width: 100%;
  color: #ff5200;
  font-family: "Lato";
  line-height: 1;
  font-size: 16px;
  font-style: italic;
  font-weight: bold;
`;
